import { makeStyles, withStyles, styled, TextField } from '@material-ui/core';
import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';

export const useStyles = makeStyles(() => ({
  activeTaskScorePanel: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
    width: '100%',
  },
  activeTaskScoreContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    alignItems: 'start',
    width: '100%',
    height: '100%',
  },

  annotationScoringInfo: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontSize: '13px',
    color: 'white',
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'start',
    alignItems: 'start',
    width: '100%',
    zIndex: 2,
  },
  taskContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    backgroundColor: '#3C419A',
    zIndex: 2,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  headerName: {
    display: 'flex',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '14px',
    color: '#2C2D3E',
    padding: '10px',
    margin: '0px',
    cursor: 'pointer',
  },
  headerScore: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '15px',
    color: '#2C2D3E',
    padding: '10px',
    margin: '0px',
  },
  activeHeader: {
    color: '#FFFFFF',
    fontWeight: 500,
    '&:focus': {
      outline: '3px solid grey',
      zIndex: 3,
    },
  },
  summary: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '14px',
    color: '#2C2D3E',
    padding: '12px 12px 12px 20px',
    margin: '0px',
  },
  scoreList: {
    listStyle: 'none',
    margin: '0px',
    paddingLeft: '0px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    color: '#2C2D3E',
    width: '100%',
    '& li': {
      margin: '12px 12px 10px 26px',
      justifyContent: 'space-between',
      cursor: 'pointer',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      '-webkit-line-clamp': 2,
      '-webkit-box-orient': 'vertical',
    },
  },
  taskScore: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
  score: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'start',
    alignItems: 'start',
    zIndex: 2,
  },

  criterionScore: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    alignItems: 'start',
    position: 'relative',
    width: '100%',
    zIndex: 2,
  },
  rowWithQualityPill: {
    backgroundColor: '#D6D6FB',
    marginTop: '5px',
  },
  sampleAssessmentScoreContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  activeScoreList: {
    listStyle: 'none',
    margin: '0px',
    paddingLeft: '0px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    color: '#FFFFFF',
    '& li': {
      margin: '12px 70px 12px 10px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      '-webkit-line-clamp': 2,
      '-webkit-box-orient': 'vertical',
    },
  },
  activeInput: {
    listStyle: 'none',
    margin: '0px',
    paddingLeft: '0px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    color: '#FFFFFF',
    padding: '12px 0px 12px 16px',
  },
  activeTaskScore: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
  activeScore: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    alignItems: 'start',
    zIndex: 2,
  },
  inputScore: {
    transform: 'translateY(5px)',
    minWidth: '55px',
  },
  cleanButtonContainer: {
    display: 'flex',
    justifyContent: 'end',
    width: '100%',
  },
  switch: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '13px',
    color: '#FFFFFF',
    paddingLeft: '30px',
  },
  errorMessage: {
    position: 'absolute',
    left: '2px',
    top: '35px',
    width: 'calc(100% - 2px)',
    height: '25px',
    background: 'white',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#BC0000',
    fontSize: '11px',
  },
  grayContainer: {
    borderRadius: '5px',
    marginRight: '10px',
    background: '#EDEDF5',
    height: 'calc(100% - 15px)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
  },
  text: {
    textAlign: 'center',
    color: '#3C419A',
    fontWeight: 700,
    fontSize: '18px',
    lineHeight: '24px',
    margin: '20px',
  },
  customTooltip: {
    backgroundColor: '#2C2D3E',
  },
  customArrow: {
    color: '#2C2D3E',
  },
  commentsIconContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  commentsIconRoundContainer: {
    width: '27px',
    height: '27px',
    borderRadius: '50%',
    backgroundColor: '#3560FF',
    textAlign: 'center',
    marginBottom: '15px',
    marginRight: '10px',
  },
  commentRequiredIcon: {
    width: '25px',
    position: 'absolute',
    right: '10px',
  },
}));

export const OrangeSwitch = styled(Switch)(() => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: '#FF9A02',
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#EDBA96',
  },
}));

export const CancelButton = withStyles(() => ({
  root: {
    width: '103px',
    padding: '0px 0px 0px 0px',
    height: '42px',
    border: 'solid 1px #3C419A',
    color: '#3C419A',
    marginLeft: '104px',
    marginBottom: '35px',
    backgroundColor: '#FFFFFF',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#FFFFFF',
      boxShadow: '0px 3px 1px 0px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 1px rgba(0,0,0,0.12)',
    },
  },
}))(Button);

export const ConfirmButton = withStyles(() => ({
  root: {
    position: 'relative',
    marginBottom: '10px',
    marginLeft: '15px',
    marginRight: '104px',
    width: '73px',
    padding: '0px 0px 0px 0px',
    height: '42px',
    border: 'solid 1px #3C419A',
    color: '#FFFFFF',
    backgroundColor: '#3C419A',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#3C419A',
      boxShadow: '0px 3px 1px 0px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 1px rgba(0,0,0,0.12)',
    },
    '&:disabled': {
      backgroundColor: '#2C2D3E4D',
      color: '#FFFFFF',
      border: 'none',
    },
  },
}))(Button);

export const InputScore = styled(TextField)({
  '& label.Mui-focused': {
    color: 'white',
    top: '-12px',
    fontSize: '13px',
  },
  '& .MuiInput-formControl': {
    marginTop: '-5px',
  },
  '& .MuiInput-underline:after': {
    borderBottom: 'solid 1px white',
  },
});
